<template>
    <v-dialog v-model="exibirMensagem" :max-width="Modal.Confirmacao.larguraMaxima" persistent>
        <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima" class="mensagem-confirmacao">
            <v-card-title class="modal-title primary white--text" primary-title dark>
                <span>{{ titulo }}</span>
            </v-card-title>

            <v-card-text class="mensagem-confirmacao__texto px-1">
                <h4 v-show="textoPrimario" class="mb-1">
                    <strong>{{ textoPrimario }}</strong>
                </h4>

                <p v-show="textoSecundario" class="mensagem-confirmacao__texto-secundario">
                    {{ textoSecundario }}
                </p>
            </v-card-text>

            <v-card-actions class="px-3 py-2">
                <v-btn id="botaoRecusar" @click="$emit('recusado')" outline depressed color="botao-cancelar-color">
                    {{ botaoRecusar }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaoConfirmar" @click="$emit('confirmado')" color="primary" depressed>
                    {{ botaoConfirmar }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'MensagemConfirmacao',
    props: {
        exibirMensagem: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Excluir'
        },
        textoPrimario: {
            type: String,
            default: ''
        },
        textoSecundario: {
            type: String,
            default: 'Deseja realmente excluir?'
        },
        botaoRecusar: {
            type: String,
            default: 'Não'
        },
        botaoConfirmar: {
            type: String,
            default: 'Sim'
        },
        tamanhoMaximo: {
            type: String,
            default: '450'
        }
    },
    data() {
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">
    .mensagem-confirmacao
        &__texto
            text-align center
            color #777

        &__texto-secundario
            width 80%
            margin 0 auto

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px

            .botao-primario
                background-color var(--v-primary-lighten1) !important
                color #fff !important
                border 1px solid var(--v-primary-lighten1)
</style>